// @mui
import { Box, Typography, Stack } from '@mui/material';
// assets
import { UploadIllustration } from '../../assets';

// ----------------------------------------------------------------------

export default function BlockContent() {
  return (
    <Stack
      alignItems="left"
      justifyContent="center"
      direction={{ xs: 'column', md: 'row' }}
      sx={{ width: 1, textAlign: { xs: 'center', md: 'center' } }}
    >
      <Box sx={{ px: 3 }}>
        <Typography variant="h5">
          Upload Image (Optional)
        </Typography>

        <Typography variant="body2" sx={{ color: 'text.secondary' }}>
          Drop files here, or click to browse.
        </Typography>
      </Box>
    </Stack>
  );
}
